<fa-icon class="{{class()}}" [size]=size() [icon]="getIconDefinition()"></fa-icon>